import { useState, useEffect } from "react";
import { Box } from "@mui/material";
import { TabsNavStyle } from "../../Theme";
import {
  activeClassMedicationHistoryTab,
  activeClassSSMedicationHistoryTab,
  pathIndex,
  TabsNavLinks,
} from "../Content";
import MenuList from "@mui/material/MenuList";
import { NavLink, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import PadSwitcher from "../PadSwitcher";

export default function TabsNav(props: any) {
  const SavedPrescriptionsState = useSelector((state: any) => {
    return { ...state.SavedPrescriptionSlice };
  }); //redux data
  const location = useLocation();
  const currentPath = location.pathname.split("/")[pathIndex];
  const [activeClass, setActiveClass] = useState(false);
  const [activeSSClass, setActiveSSClass] = useState(false);
  useEffect(() => {
    activeClassMedicationHistoryTab.includes(currentPath) &&
      setActiveClass(true);
    activeClassSSMedicationHistoryTab.includes(currentPath) &&
      setActiveSSClass(true);
  }, []);
  return (
    <TabsNavStyle className="rxtabsnav">
      <MenuList
        sx={{
          flexWrap: "nowrap",
          alignItems: "center",
          width: "max-content",
          minWidth: "100%",
          overflow: "visible",
        }}
      >
        {/* Single pad switcher — replaces the old "New Rx Pad" tab. Switches
            between Agentic Rx Pad and New Rx Pad. Prescription state persists in
            a module-level store that survives component unmounting, so no auto-save
            is needed on pad switching. */}
        <Box sx={{ display: "flex", alignItems: "center", pr: 1.5, flexShrink: 0 }}>
          <PadSwitcher />
        </Box>
        {/* {sessionStorage.getItem("freeTextRxTabs") &&
          FreeTextRxPadTabsNavLinks.map((navlink, index) => {
            return (
              <NavLink
                className={
                  "MuiMenuItem-root MuiMenuItem-gutters MuiButtonBase-root  "
                }
                key={index}
                to={navlink.path}
              >
                {navlink.name}
              </NavLink>
            );
          })} */}
        {TabsNavLinks.map((navlink, index) => {
          {
            if (navlink.path === "medicationshistory") {
              return (
                <NavLink
                  className={
                    activeClass
                      ? `${navlink.class} MuiMenuItem-root MuiMenuItem-gutters MuiButtonBase-root active `
                      : `${navlink.class} MuiMenuItem-root MuiMenuItem-gutters MuiButtonBase-root  `
                  }
                  key={index}
                  to={navlink?.path}
                >
                  {navlink.name}
                </NavLink>
              );
            } else if (navlink.path === "ssmedicationhistory") {
              return (
                <NavLink
                  className={
                    activeSSClass
                      ? `${navlink.class} MuiMenuItem-root MuiMenuItem-gutters MuiButtonBase-root active `
                      : `${navlink.class} MuiMenuItem-root MuiMenuItem-gutters MuiButtonBase-root  `
                  }
                  key={index}
                  to={navlink?.path}
                >
                  {navlink.name}
                </NavLink>
              );
            } else {
              return (
                <NavLink
                  className={`${navlink.class} MuiMenuItem-root MuiMenuItem-gutters MuiButtonBase-root  `}
                  key={index}
                  to={navlink?.path}
                >
                  {navlink.name === "Saved Prescriptions" &&
                  SavedPrescriptionsState?.Items?.length > 0 ? (
                    <>
                      <b style={{ fontSize: 30, color: "red" }}>*</b>
                      {navlink.name}
                    </>
                  ) : (
                    navlink.name
                  )}
                </NavLink>
              );
            }
          }
        })}
      </MenuList>
    </TabsNavStyle>
  );
}
